import {useMemo} from 'react';
import {useSelector} from 'react-redux';

/**
 * Returns the filter parameters for the active participants of a specific event.
 *
 * @param {number} eventId - The ID of the event.
 * @return {object} The filter parameters for the active participants of the event.
 */
export function useActiveParticipantsFilter(eventId) {
    const selector = useMemo(() => state => state.events[eventId]?.participants.filterParams, [eventId]);
    return useSelector(selector);
}
